import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { keyDown } from '../../../utils/helpers';
import ToggleSection from '../Account/ToggleSection';
import { formatAmountWithoutDecimals } from '../../../utils/helpers';

interface ContainerProps {
  disabled?: boolean;
  page?: string;
}

const StyledOuterContainer = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  padding: 16px 0;


  ${(props: any) =>
    props.page === 'IncomeExpenses' &&
    css`
      :nth-of-type(2),
      :nth-of-type(4) {
        border-top: 1px solid ${tokens.ColorBrandBrightBlue};
      }
      border-right: none;
      border-left: none;
      border-bottom: none;
      margin-bottom: 0;
      box-shadow: none;
      min-height: auto;
    `}
`;

const StyledContainer = styled.div<ContainerProps>`
  width: 100%;
  border: none;
  background-color: ${tokens.ColorWhite000};
  display: flex;
  cursor: pointer;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  color: ${tokens.ColorGrey600};
  ${(props: any) =>
    props.disabled &&
    css`
      color: #6b7880;
    `}
`;

const StyledHoverableSection = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  ${(props: any) =>
    props.page === 'IncomeExpenses' &&
    css`
      padding: 16px 16px 16px 0;
    `}
`;

const IncomeExpensesInfoText = css`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey600};
`;

const IncomeExpensesName = styled.div<ContainerProps>`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorBrandInteractiveBlue};
  ${(props: any) =>
    props.disabled &&
    css`
      color: #6b7880;
    `}
`;

const StyledBalance = styled.div<ContainerProps>`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey800};
  ${(props: any) =>
    props.disabled &&
    css`
      color: #6b7880;
    `}
`;

const StyledAccountInfo = styled.div`
  @media (max-width: 767px) {
    margin-bottom: 8px;
  }
`;

const StyledAccountType = styled.div`
  ${IncomeExpensesInfoText}
`;

const StyledAge = styled.div`
  ${IncomeExpensesInfoText}
`;

const StyledBalanceContainer = styled.div`
  text-align: right;
  padding-right: 16px;
  @media (max-width: 767px) {
    text-align: left;
  }
`;

class IncomeExpensesCard extends Component<any> {
  props: any;
  state: any;

  render(): JSX.Element {
    const { onClick, disabled, handleIncludeExclude, accHolder } = this.props;
    const { page, includeInScenario, id, accountHolder, name, balance, amount, endNumber, startNumber, typeName, owner, age, frequency } = this.props.data;

    return (
      <React.Fragment>
        <StyledOuterContainer
          page={page}
          onClick={onClick}
          tabIndex={0}
          onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, onClick)}
        >
          <StyledContainer disabled={disabled}>
            <StyledHoverableSection tabIndex={0} page={page}>
              <StyledAccountInfo>
                <IncomeExpensesName disabled={disabled} page={page}>
                  {name} 
                </IncomeExpensesName>
                <StyledAccountType>
                  {typeName} | {accountHolder ? accountHolder : accHolder}
                </StyledAccountType>
              </StyledAccountInfo>
              <StyledBalanceContainer>
                <StyledBalance disabled={disabled}>{
                  frequency === 'ONET' ?
                    formatAmountWithoutDecimals(amount)
                    :
                    frequency === 'MLY' || typeName?.includes('Monthly') || typeName === 'Annuity' ?
                      formatAmountWithoutDecimals(amount) + `/mo`
                      :
                      formatAmountWithoutDecimals(amount) + `/yr`}</StyledBalance>
                <StyledAge>{`age ` + (endNumber ? endNumber : age ? age : startNumber)}</StyledAge>
              </StyledBalanceContainer>
            </StyledHoverableSection>
            {/* <ToggleSection isOn={includeInScenario} id={id} handleIncludeExclude={handleIncludeExclude} /> */}
          </StyledContainer>
        </StyledOuterContainer>
      </React.Fragment>
    );
  }
}

export default IncomeExpensesCard;
